import { Component, OnInit } from '@angular/core';
import { Account, Channel } from 'src/app/interfaces';
import { AccountService } from 'src/app/services/account.service';
import { ChannelService } from 'src/app/services/channel.service';

@Component({
  selector: 'vl-channels',
  standalone: true,
  imports: [],
  templateUrl: './channels.component.html',
  styleUrl: './channels.component.scss'
})
export class ChannelsComponent implements OnInit {

  private account: Account = <Account>{}
  private channels: Channel[] = <Channel[]>[]

  constructor(private accountService: AccountService, private channelService: ChannelService) {
    this.accountService.getAccount$().subscribe((account) => {
      if (account._id) {
        this.channelService.getChannelsByAccountId(account._id).subscribe((channels) => {
          this.channels = channels;
        });
        this.account = account;
      }
    });
  }

  ngOnInit(): void {

  }

}
